import { useTranslation } from 'react-i18next';

type LinkedCasesActionButtonProps = {
  connectedAgdFileRefAvailable: boolean;
  caseRequestId?: string;
  onOpen: (caseRequestId: string) => void;
};

export default function LinkedCasesActionButton({
  connectedAgdFileRefAvailable,
  caseRequestId,
  onOpen,
}: LinkedCasesActionButtonProps) {
  const { t } = useTranslation();
  const id = caseRequestId?.trim() ?? '';
  const canOpen = connectedAgdFileRefAvailable && Boolean(id);
  const tip = canOpen
    ? t('tasks.shared.viewLinkedCases')
    : t('tasks.shared.linkedCasesUnavailable');

  return (
    <button
      type="button"
      className="act-b"
      data-tip={tip}
      aria-label={tip}
      disabled={!canOpen}
      onClick={() => {
        if (!canOpen) return;
        onOpen(id);
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
    </button>
  );
}
